const roles = {
  user: 1,
};

export default roles;

export function roleName(role) {
  switch (role) {
    case roles.user:
      return "Пользователь";
    default:
      return "Неопределенная роль";
  }
}
